// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataTable-module_outer_container_nSbcV {
  display: flex;
  height: 100%;
}

.DataTable-module_table_settings_box_g1Jtr {
  padding: 8px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: clip;
}

.DataTable-module_table_settings_button_Teti_ {
}

.DataTable-module_table_box_rozbV {
  --bp-light-gray1: #d3d8de;
  --bp-light-gray5: #f6f7f9;
  --bp-dark-gray4: #383e47;
  --table-tools-empty-height: 0px;
  --table-tools-height: 44px;
  --header-height: 60px;
  --short-header-height: 50px;
  --footer-height: 48px;
}

.DataTable-module_table_box_rozbV {
  height: 100%;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.DataTable-module_table_box_no_tools_no_filter_t2R5s {
}

.DataTable-module_table_box_no_tools_yes_filter__4WB7 {
}

.DataTable-module_table_box_yes_tools_no_filter_KDyvx {
}

.DataTable-module_table_box_yes_tools_yes_filter_dmRNI {
}

.DataTable-module_table_tools_box_MC7Ru {
  height: var(--table-tools-height);
  width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  z-index: 2;
  position: sticky;
  top: 0;
  left: 0;
  padding: 0 20px;
  border-bottom: 1px solid var(--bp-light-gray1);
  flex-shrink: 0;
}

.DataTable-module_table_tools_box_empty_DU8Cq {
  height: var(--table-tools-empty-height);
}

.DataTable-module_data_table_container_gXcAs {
  max-height: 100%;
  width: 100%;
  overflow: hidden;
}

.DataTable-module_data_table_container_busy_R0yWx {
}

.DataTable-module_data_table_container_busy_R0yWx .DataTable-module_table_cell_cHP8m {
  opacity: 0.6;
}

.DataTable-module_data_table_d1ADV {
  background-color: white;
}

.DataTable-module_data_table_header_div_u_hAU {
  display: flex;
  font-weight: 700;
  font-size: 14px;
  padding: 0 7px 0 7px;
  align-items: center;
  width: 100%;
  height: 100%;
  color: var(--text-color);
}

.DataTable-module_data_table_cell_header_ZUsNU {
  background-color: var(--bp-light-gray4);
  box-shadow: none !important;
  border-bottom: 1px solid var(--bp-light-gray1);
  height: var(--header-height);
}

.DataTable-module_data_table_cell_header_ZUsNU > div:nth-child(2) {
  height: 100%;
}

.DataTable-module_short_cell_header_TO96P {
  height: var(--short-header-height);
}

.DataTable-module_header_with_resizer_mzTwJ {
}

.DataTable-module_header_with_resizer_mzTwJ:hover {
  border-right: 1px solid var(--bp-light-gray1);
}

/* .header_with_resizer:hover::after { */
/*     content: ''; */
/*     background: var(--bp-light-gray1); */
/*     position: absolute; */
/*     bottom: 0px; */
/*     right: 0; */
/*     height: 40px; */
/*     width: 1px; */
/* } */

.DataTable-module_hidden_header_s2PoR {
}

.DataTable-module_hidden_header_s2PoR > div,
.DataTable-module_hidden_header_s2PoR .DataTable-module_data_table_header_div_u_hAU {
  display: none;
}

.DataTable-module_header_sort_icon_InRL3 {
  margin-left: 0;
  padding: 0 8px !important;
  z-index: 10;
  /* background: var(--bp-light-gray4) !important; */
  min-width: unset !important;
  position: relative;
  left: 3px;
  top: -1px;
}

.DataTable-module_hidden_header_s2PoR .DataTable-module_header_sort_icon_InRL3 {
  display: none;
}

.DataTable-module_header_text_aa2Er {
  white-space: nowrap;
  overflow: hidden;
}

.DataTable-module_data_table_header_div_u_hAU .DataTable-module_bp5-popover-target_ibeIP {
  display: flex;
}

.DataTable-module_header_text_aa2Er .DataTable-module_bp5-popover-target_ibeIP:has(.DataTable-module_header_sort_icon_InRL3) {
  flex-grow: 0;
  flex-shrink: 0;
  background: var(--bp-light-gray4);
  margin-right: auto;
}

.DataTable-module_header_text_filterable_ZcuEn {
  cursor: pointer;
  /* max-width: calc(100% - 12px); */
  flex-grow: 1;
  flex-shrink: 1;
}

.DataTable-module_header_text_filterable_ZcuEn:hover {
  color: var(--primary-hover-color);
}

.DataTable-module_header_filter_icon_U1laj {
  cursor: pointer;
  margin-left: 4px;
}

.DataTable-module_header_filter_icon_U1laj:hover {
  color: var(--primary-hover-color);
}

.DataTable-module_header_clear_filter_button_drYA_ {
  margin-top: 16px;
  min-width: unset !important;
  padding: 0 6px !important;
}

.DataTable-module_centered_header_C4Y6S {
  justify-content: center;
}

.DataTable-module_data_table_row_header_F2JAF {
  background-color: white;
  box-shadow: none !important;
  width: 100%;
  padding: 0;
}

.DataTable-module_data_table_row_header_checkbox_Dqs8I {
}

.DataTable-module_data_table_row_header_F2JAF:not(.DataTable-module_data_table_row_header_checkbox_Dqs8I) > div:first-child {
  height: 100%;
  width: 100%;
  padding: 0;
}

.DataTable-module_data_table_clickable_cell_vEGIQ {
  cursor: pointer;
  height: 100%;
  width: 100%;
}

.DataTable-module_data_table_row_header_F2JAF::before {
  bottom: 0 !important;
}

.DataTable-module_data_table_row_header_checkbox_Dqs8I::before {
  display: none;
}

.DataTable-module_data_table_row_header_F2JAF:not(.DataTable-module_selected_cell_NOOYN):hover::before {
  background-color: white !important;
}

.DataTable-module_table_cell_cHP8m {
  display: flex;
  color: var(--bp-dark-gray4);
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
  padding: 0 7px 0 7px;
}

.DataTable-module_table_cell_small_font_UuZ1b {
  font-size: 12px;
}

.DataTable-module_table_cell_cHP8m:not(.DataTable-module_icon_cell_bzkpM):not(.DataTable-module_checkbox_cell_T2EUf) > div {
  width: 100%;
}

.DataTable-module_align_center_CLxxk {
  align-items: center;
}

.DataTable-module_text_center_TOruL {
  text-align: center;
}

.DataTable-module_table_cell_small_font_bordered_kGngE {
  border-bottom: 1px solid var(--bp-light-gray1);
}

.DataTable-module_table_cell_bordered_CEKJ9 {
  border-bottom: 1px solid var(--bp-light-gray1);
}

.DataTable-module_table_cell_required_CqDKD {
}

.DataTable-module_table_cell_required_CqDKD:before {
  content: ' ';
  position: absolute;
  left: 4px;
  right: 4px;
  top: 4px;
  bottom: 4px;
  border: 2px solid var(--site-warning-color);
  pointer-events: none;
}

.DataTable-module_icon_cell_bzkpM {
  padding: 0;
  justify-content: center;
}

.DataTable-module_checkbox_header_containing_rB1L3 {
  position: relative;
  height: 0;
  width: 0;
  overflow: visible;
}

.DataTable-module_checkbox_header_ATFiU {
  position: absolute;
  top: 22px;
  left: 7px;
  z-index: 1;
}

.DataTable-module_checkbox_cell_T2EUf {
  height: 100%;
  width: 100%;
  padding: 0;
  justify-content: center;
}

.DataTable-module_checkbox_XQ28K,
.DataTable-module_checkbox_XQ28K span,
.DataTable-module_checkbox_XQ28K input {
  margin: 0 !important;
  padding: 0 !important;
}

.DataTable-module_selected_cell_NOOYN {
  background-color: var(--selected-row-bg-color);
}

.DataTable-module_data_table_row_header_F2JAF.DataTable-module_selected_cell_NOOYN:hover::before {
  background-color: var(--selected-row-bg-color) !important;
}

.DataTable-module_highlighted_cell_s4el5 {
  color: var(--muted-text);
  font-style: italic;
  font-weight: 400;
}

.DataTable-module_money_cell_HVT5j {
  text-align: right;
  justify-content: end;
  padding-right: 10px;
  /* flex-direction: row-reverse; */
}

.DataTable-module_dummy_cell_SyY70 {
  background-color: white;
  width: 100%;
  min-width: 20px;
  max-width: 20px;
}

.DataTable-module_truncated_cell_ojxFh {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  white-space: nowrap;
}

.DataTable-module_truncated_cell_ojxFh > * {
  text-overflow: clip;
  position: relative;
}

.DataTable-module_truncated_cell_ojxFh > div {
  left: 0;
}

.DataTable-module_truncated_cell_ojxFh > span {
  right: 0;
}

.DataTable-module_no_border_BTaE4 {
  border: none !important;
}

.DataTable-module_paging_footer_t7BRc {
  position: sticky;
  bottom: 0;
  padding-right: 20px;
  width: 100%;
  height: var(--footer-height);
  background-color: var(--bp-light-gray4);
  border-top: 1px solid var(--bp-light-gray1);
  z-index: 1;
  display: flex;
  column-gap: 16px;
  align-items: center;
  justify-content: end;
  flex-shrink: 0;
}

.DataTable-module_divider_tm7aG {
  height: 30px;
  border-color: var(--bp-gray4) !important;
}

.DataTable-module_small_font_F2PjB {
  font-size: 12px;
}

.DataTable-module_hidden_column_dMWRJ {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/AdvancedDataTable/DataTable.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,eAAe;EACf,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EAEE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;AAEA;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC,qBAAqB;AACrB,2CAA2C;AAC3C,4BAA4B;AAC5B,qBAAqB;AACrB,kBAAkB;AAClB,sBAAsB;AACtB,oBAAoB;AACpB,MAAM;;AAEN;AAEA;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,kDAAkD;EAClD,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EAEE,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,UAAU;AACZ;;AAEA;AAEA;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EAEE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,uBAAuB;AACzB;;AAEA;;;EAGE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,uCAAuC;EACvC,2CAA2C;EAC3C,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".outer_container {\n  display: flex;\n  height: 100%;\n}\n\n.table_settings_box {\n  padding: 8px;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n  overflow-x: clip;\n}\n\n.table_settings_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n}\n\n.table_box {\n  --bp-light-gray1: #d3d8de;\n  --bp-light-gray5: #f6f7f9;\n  --bp-dark-gray4: #383e47;\n  --table-tools-empty-height: 0px;\n  --table-tools-height: 44px;\n  --header-height: 60px;\n  --short-header-height: 50px;\n  --footer-height: 48px;\n}\n\n.table_box {\n  height: 100%;\n  width: 100%;\n  border-radius: 2px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.table_box_no_tools_no_filter {\n  composes: table_box;\n}\n\n.table_box_no_tools_yes_filter {\n  composes: table_box;\n}\n\n.table_box_yes_tools_no_filter {\n  composes: table_box;\n}\n\n.table_box_yes_tools_yes_filter {\n  composes: table_box;\n}\n\n.table_tools_box {\n  height: var(--table-tools-height);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background-color: white;\n  z-index: 2;\n  position: sticky;\n  top: 0;\n  left: 0;\n  padding: 0 20px;\n  border-bottom: 1px solid var(--bp-light-gray1);\n  flex-shrink: 0;\n}\n\n.table_tools_box_empty {\n  composes: table_tools_box;\n  height: var(--table-tools-empty-height);\n}\n\n.data_table_container {\n  max-height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.data_table_container_busy {\n  composes: data_table_container;\n}\n\n.data_table_container_busy .table_cell {\n  opacity: 0.6;\n}\n\n.data_table {\n  background-color: white;\n}\n\n.data_table_header_div {\n  display: flex;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 0 7px 0 7px;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  color: var(--text-color);\n}\n\n.data_table_cell_header {\n  background-color: var(--bp-light-gray4);\n  box-shadow: none !important;\n  border-bottom: 1px solid var(--bp-light-gray1);\n  height: var(--header-height);\n}\n\n.data_table_cell_header > div:nth-child(2) {\n  height: 100%;\n}\n\n.short_cell_header {\n  height: var(--short-header-height);\n}\n\n.header_with_resizer {\n  composes: data_table_cell_header;\n}\n\n.header_with_resizer:hover {\n  border-right: 1px solid var(--bp-light-gray1);\n}\n\n/* .header_with_resizer:hover::after { */\n/*     content: ''; */\n/*     background: var(--bp-light-gray1); */\n/*     position: absolute; */\n/*     bottom: 0px; */\n/*     right: 0; */\n/*     height: 40px; */\n/*     width: 1px; */\n/* } */\n\n.hidden_header {\n  composes: data_table_cell_header;\n}\n\n.hidden_header > div,\n.hidden_header .data_table_header_div {\n  display: none;\n}\n\n.header_sort_icon {\n  margin-left: 0;\n  padding: 0 8px !important;\n  z-index: 10;\n  /* background: var(--bp-light-gray4) !important; */\n  min-width: unset !important;\n  position: relative;\n  left: 3px;\n  top: -1px;\n}\n\n.hidden_header .header_sort_icon {\n  display: none;\n}\n\n.header_text {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.data_table_header_div .bp5-popover-target {\n  display: flex;\n}\n\n.header_text .bp5-popover-target:has(.header_sort_icon) {\n  flex-grow: 0;\n  flex-shrink: 0;\n  background: var(--bp-light-gray4);\n  margin-right: auto;\n}\n\n.header_text_filterable {\n  composes: header_text;\n  cursor: pointer;\n  /* max-width: calc(100% - 12px); */\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.header_text_filterable:hover {\n  color: var(--primary-hover-color);\n}\n\n.header_filter_icon {\n  cursor: pointer;\n  margin-left: 4px;\n}\n\n.header_filter_icon:hover {\n  color: var(--primary-hover-color);\n}\n\n.header_clear_filter_button {\n  margin-top: 16px;\n  min-width: unset !important;\n  padding: 0 6px !important;\n}\n\n.centered_header {\n  justify-content: center;\n}\n\n.data_table_row_header {\n  background-color: white;\n  box-shadow: none !important;\n  width: 100%;\n  padding: 0;\n}\n\n.data_table_row_header_checkbox {\n  composes: data_table_row_header;\n}\n\n.data_table_row_header:not(.data_table_row_header_checkbox) > div:first-child {\n  height: 100%;\n  width: 100%;\n  padding: 0;\n}\n\n.data_table_clickable_cell {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n}\n\n.data_table_row_header::before {\n  bottom: 0 !important;\n}\n\n.data_table_row_header_checkbox::before {\n  display: none;\n}\n\n.data_table_row_header:not(.selected_cell):hover::before {\n  background-color: white !important;\n}\n\n.table_cell {\n  display: flex;\n  color: var(--bp-dark-gray4);\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: none;\n  padding: 0 7px 0 7px;\n}\n\n.table_cell_small_font {\n  composes: table_cell;\n  font-size: 12px;\n}\n\n.table_cell:not(.icon_cell):not(.checkbox_cell) > div {\n  width: 100%;\n}\n\n.align_center {\n  align-items: center;\n}\n\n.text_center {\n  text-align: center;\n}\n\n.table_cell_small_font_bordered {\n  composes: table_cell_small_font;\n  border-bottom: 1px solid var(--bp-light-gray1);\n}\n\n.table_cell_bordered {\n  composes: table_cell;\n  border-bottom: 1px solid var(--bp-light-gray1);\n}\n\n.table_cell_required {\n}\n\n.table_cell_required:before {\n  content: ' ';\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  border: 2px solid var(--site-warning-color);\n  pointer-events: none;\n}\n\n.icon_cell {\n  padding: 0;\n  justify-content: center;\n}\n\n.checkbox_header_containing {\n  position: relative;\n  height: 0;\n  width: 0;\n  overflow: visible;\n}\n\n.checkbox_header {\n  position: absolute;\n  top: 22px;\n  left: 7px;\n  z-index: 1;\n}\n\n.checkbox_cell {\n  composes: table_cell;\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  justify-content: center;\n}\n\n.checkbox,\n.checkbox span,\n.checkbox input {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.selected_cell {\n  background-color: var(--selected-row-bg-color);\n}\n\n.data_table_row_header.selected_cell:hover::before {\n  background-color: var(--selected-row-bg-color) !important;\n}\n\n.highlighted_cell {\n  color: var(--muted-text);\n  font-style: italic;\n  font-weight: 400;\n}\n\n.money_cell {\n  text-align: right;\n  justify-content: end;\n  padding-right: 10px;\n  /* flex-direction: row-reverse; */\n}\n\n.dummy_cell {\n  background-color: white;\n  width: 100%;\n  min-width: 20px;\n  max-width: 20px;\n}\n\n.truncated_cell {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.truncated_cell > * {\n  text-overflow: clip;\n  position: relative;\n}\n\n.truncated_cell > div {\n  left: 0;\n}\n\n.truncated_cell > span {\n  right: 0;\n}\n\n.no_border {\n  border: none !important;\n}\n\n.paging_footer {\n  position: sticky;\n  bottom: 0;\n  padding-right: 20px;\n  width: 100%;\n  height: var(--footer-height);\n  background-color: var(--bp-light-gray4);\n  border-top: 1px solid var(--bp-light-gray1);\n  z-index: 1;\n  display: flex;\n  column-gap: 16px;\n  align-items: center;\n  justify-content: end;\n  flex-shrink: 0;\n}\n\n.divider {\n  height: 30px;\n  border-color: var(--bp-gray4) !important;\n}\n\n.small_font {\n  font-size: 12px;\n}\n\n.hidden_column {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outer_container": `DataTable-module_outer_container_nSbcV`,
	"table_settings_box": `DataTable-module_table_settings_box_g1Jtr`,
	"table_settings_button": `DataTable-module_table_settings_button_Teti_ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"table_box": `DataTable-module_table_box_rozbV`,
	"table_box_no_tools_no_filter": `DataTable-module_table_box_no_tools_no_filter_t2R5s DataTable-module_table_box_rozbV`,
	"table_box_no_tools_yes_filter": `DataTable-module_table_box_no_tools_yes_filter__4WB7 DataTable-module_table_box_rozbV`,
	"table_box_yes_tools_no_filter": `DataTable-module_table_box_yes_tools_no_filter_KDyvx DataTable-module_table_box_rozbV`,
	"table_box_yes_tools_yes_filter": `DataTable-module_table_box_yes_tools_yes_filter_dmRNI DataTable-module_table_box_rozbV`,
	"table_tools_box": `DataTable-module_table_tools_box_MC7Ru`,
	"table_tools_box_empty": `DataTable-module_table_tools_box_empty_DU8Cq DataTable-module_table_tools_box_MC7Ru`,
	"data_table_container": `DataTable-module_data_table_container_gXcAs`,
	"data_table_container_busy": `DataTable-module_data_table_container_busy_R0yWx DataTable-module_data_table_container_gXcAs`,
	"table_cell": `DataTable-module_table_cell_cHP8m`,
	"data_table": `DataTable-module_data_table_d1ADV`,
	"data_table_header_div": `DataTable-module_data_table_header_div_u_hAU`,
	"data_table_cell_header": `DataTable-module_data_table_cell_header_ZUsNU`,
	"short_cell_header": `DataTable-module_short_cell_header_TO96P`,
	"header_with_resizer": `DataTable-module_header_with_resizer_mzTwJ DataTable-module_data_table_cell_header_ZUsNU`,
	"hidden_header": `DataTable-module_hidden_header_s2PoR DataTable-module_data_table_cell_header_ZUsNU`,
	"header_sort_icon": `DataTable-module_header_sort_icon_InRL3`,
	"header_text": `DataTable-module_header_text_aa2Er`,
	"bp5-popover-target": `DataTable-module_bp5-popover-target_ibeIP`,
	"header_text_filterable": `DataTable-module_header_text_filterable_ZcuEn DataTable-module_header_text_aa2Er`,
	"header_filter_icon": `DataTable-module_header_filter_icon_U1laj`,
	"header_clear_filter_button": `DataTable-module_header_clear_filter_button_drYA_`,
	"centered_header": `DataTable-module_centered_header_C4Y6S`,
	"data_table_row_header": `DataTable-module_data_table_row_header_F2JAF`,
	"data_table_row_header_checkbox": `DataTable-module_data_table_row_header_checkbox_Dqs8I DataTable-module_data_table_row_header_F2JAF`,
	"data_table_clickable_cell": `DataTable-module_data_table_clickable_cell_vEGIQ`,
	"selected_cell": `DataTable-module_selected_cell_NOOYN`,
	"table_cell_small_font": `DataTable-module_table_cell_small_font_UuZ1b DataTable-module_table_cell_cHP8m`,
	"icon_cell": `DataTable-module_icon_cell_bzkpM`,
	"checkbox_cell": `DataTable-module_checkbox_cell_T2EUf DataTable-module_table_cell_cHP8m`,
	"align_center": `DataTable-module_align_center_CLxxk`,
	"text_center": `DataTable-module_text_center_TOruL`,
	"table_cell_small_font_bordered": `DataTable-module_table_cell_small_font_bordered_kGngE DataTable-module_table_cell_small_font_UuZ1b DataTable-module_table_cell_cHP8m`,
	"table_cell_bordered": `DataTable-module_table_cell_bordered_CEKJ9 DataTable-module_table_cell_cHP8m`,
	"table_cell_required": `DataTable-module_table_cell_required_CqDKD`,
	"checkbox_header_containing": `DataTable-module_checkbox_header_containing_rB1L3`,
	"checkbox_header": `DataTable-module_checkbox_header_ATFiU`,
	"checkbox": `DataTable-module_checkbox_XQ28K`,
	"highlighted_cell": `DataTable-module_highlighted_cell_s4el5`,
	"money_cell": `DataTable-module_money_cell_HVT5j`,
	"dummy_cell": `DataTable-module_dummy_cell_SyY70`,
	"truncated_cell": `DataTable-module_truncated_cell_ojxFh`,
	"no_border": `DataTable-module_no_border_BTaE4`,
	"paging_footer": `DataTable-module_paging_footer_t7BRc`,
	"divider": `DataTable-module_divider_tm7aG`,
	"small_font": `DataTable-module_small_font_F2PjB`,
	"hidden_column": `DataTable-module_hidden_column_dMWRJ`
};
export default ___CSS_LOADER_EXPORT___;
